export default "__VITE_ASSET__D9XmMbbz__"